import { useAuthStore } from '@/stores/retailer/auth.js'

export default function retailerNotRequireAuth(to, from, next) {
  const authStore = useAuthStore()
  if (authStore.getToken) {
    const redirect = to.query.redirect
    next(typeof redirect === 'string' && redirect.startsWith('/retailer') ? redirect : '/retailer')
    return
  } else {
    next()
    return
  }
}
